import { CompanyResponse, CompanyEntity, UpdateCompanyAuthMethodFormEntity } from 'src/types'
import { UpdateCompanyAuthMethodRequest } from 'src/types/requests/Company'

export const CompanyTranslator = {
  toEntity(response: CompanyResponse): CompanyEntity {
    return {
      id: response.id,
      name: response.name,
      isIDPassEnabled: response.isIDPassEnabled,
      isSAMLEnabled: response.isSAMLEnabled,
    }
  },

  toUpdateCompanyAuthMethodRequest: (
    formEntity: UpdateCompanyAuthMethodFormEntity
  ): UpdateCompanyAuthMethodRequest => {
    return {
      isIDPassEnabled: formEntity.isIDPassEnabled,
      isSAMLEnabled: formEntity.isSAMLEnabled,
    }
  },
} as const
